// extracted by mini-css-extract-plugin
export default {"container":"SegmentGrowthSection_container__z4X1c"};